/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const PaymentDetailsInfo = ({
  processing,
  totalDiscount = '',
  credits,
  priceUnit,
  moneyNeedToPay = '',
}) => {
  return (
    <div className="booking-payment-details-info my-5 md:w-3/4 mx-auto">
      <h2 className="text-2xl font-semibold text-center">Payment Details</h2>
      <div className="table my-5 border-b w-full">
        <ul className="header flex items-start justify-between">
          <li className="w-1/3 font-semibold">Description</li>
          <li className="w-1/3 font-semibold">Quantity</li>
          <li className="w-1/3 font-semibold">Unit Price</li>
        </ul>
        <ul className="data flex items-start justify-between my-3">
          <li className="w-1/3 font-light">Passport</li>
          <li className="w-1/3 font-light">{credits}</li>
          <li className="w-1/3 font-light">{priceUnit}</li>
        </ul>
      </div>
      <div className="flex justify-around">
        <p className="font-bold text-lg">Discount</p>
        <p className="font-bold text-lg">{totalDiscount}</p>
      </div>
      <div className="flex justify-around">
        <p className="font-bold text-lg">Amount Due</p>
        <p className="font-bold text-lg">{moneyNeedToPay}</p>
      </div>
      <div className="flex justify-center mt-10">
        <button
          disabled={processing}
          className={`btn-primary px-12 py-3 rounded-lg ${
            processing && 'bg-secondary-graywhite cursor-not-allowed text-primary-lightgray'
          }`}
          type="submit"
        >
          {processing ? 'Confirming Payment...' : 'Confirm Payment'}
        </button>
      </div>
    </div>
  )
}
PaymentDetailsInfo.propTypes = {
  processing: PropTypes.bool.isRequired,
  totalDiscount: PropTypes.string,
  credits: PropTypes.string,
  priceUnit: PropTypes.string,
  moneyNeedToPay: PropTypes.string,
}

const mapStateToProps = ({ passport, promocodes }) => {
  const currency =
    passport.paymentDetail?.currency || promocodes?.promo_discount?.promotion?.currency
  const planDetails = passport.planDetails
  let amount = planDetails.price
  const priceUnit = `${currency} ${passport.paymentDetail?.priceUnit || planDetails.price}`
  const totalMoney = passport.paymentDetail?.price || amount
  let moneyNeedToPay = `${currency} ${passport.paymentDetail?.price || amount}`
  const promotionValid = promocodes?.promo_discount?.valid || false
  const totalDiscount = `${currency} ${promocodes?.promo_discount?.promotion?.total_discount || 0}`
  if (promotionValid) {
    moneyNeedToPay = `${currency} ${promocodes.promo_discount.promotion.total_need_to_pay}`
  }
  const credits = passport.paymentDetail?.credits || '1'
  return {
    processing: passport.processing,
    totalDiscount,
    amount,
    totalMoney: `${currency} ${totalMoney}`,
    credits,
    priceUnit,
    moneyNeedToPay,
  }
}

export default connect(mapStateToProps)(PaymentDetailsInfo)
